import React from 'react';
import {IconProps} from './IconProps';

export default function FlameIcon(props: IconProps) {
  const {width = 20, height = 20, color = '#fdd06a'} = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fill={color}
        d="M9.52380952,0 C11.7464762,8.888 6.85714286,11.6666667 6.85714286,11.6666667 L6.85714286,7.156 C4.58114286,8.14666667 2.85714286,10.536 2.85714286,13.3333333 C2.85714286,17.016 5.84114286,20 9.52380952,20 C13.2064762,20 16.1904762,17.016 16.1904762,13.3333333 C16.1904762,9.89866667 16.1904762,6.66666667 9.52380952,0 Z"
      />
    </svg>
  );
}
